import React, { PureComponent } from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { compose, withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import withSounds from 'containers/withSounds';
import { PROPERTY_CHICAGO_SOUTHLAND } from 'utils/constants';
import { getUserData } from 'utils/graphQLFunctions';
import { incNewRewardsCount, setNewRewardsCount } from './actions';
import { selectNewRewardsCount } from './selectors';
import rewardsIcon from './cv-rewards-button.svg';
import './RewardsButton.css';

const GET_USER_NEW_OFFERS = gql`
  query {
    patronAssets {
      offersUnseenCount
    }
  }
`;

const SUBSCRIPTION_USER_NEW_OFFERS = gql`
  subscription {
    newOffers {
      newOffersAsPatronRewards {
        prizeCode
        onlineOfferUuid
      }
    }
  }
`;

class RewardsButton extends PureComponent {
  async componentDidMount() {
    await this.queryNewOffersCount();
  }

  componentWillUnmount() {
    this.unsubscribeFromNewOffersUpdate();
  }

  async queryNewOffersCount() {
    try {
      let resp = await this.props.client.query({
        query: GET_USER_NEW_OFFERS
      });
      const count =
        (resp.data.patronAssets && resp.data.patronAssets.offersUnseenCount) ||
        0;
      this.props.setNewRewardsCount(count);
      this.subscribeToNewOffersUpdate();
    } catch (e) {
      console.error('queryNewOffersCount exception', e);
    }
  }

  subscribeToNewOffersUpdate() {
    this.unsubscribeFromNewOffersUpdate();

    this.newOffersUpdateListener = this.props.client
      .subscribe({
        query: SUBSCRIPTION_USER_NEW_OFFERS
      })
      .subscribe({
        next: subscriptionData => {
          if (
            subscriptionData &&
            subscriptionData.data &&
            subscriptionData.data.newOffersAsPatronRewards
          ) {
            let newRewardsCount = Array.from(
              new Set(
                subscriptionData.data.newOffersAsPatronRewards.map(
                  s => s.prizeCode
                )
              )
            ).map(prizeCode => {
              return subscriptionData.data.newOffersAsPatronRewards.find(
                a => a.prizeCode === prizeCode
              );
            }).length;

            this.props.setNewRewardsCount(
              this.props.newRewardsCount + newRewardsCount
            );
          }
        }
      });
  }

  unsubscribeFromNewOffersUpdate() {
    if (this.newOffersUpdateListener) {
      this.newOffersUpdateListener.unsubscribe();
      this.newOffersUpdateListener = null;
    }
  }

  render() {
    const { newRewardsCount, userData, className } = this.props;
    const preferredLocation = userData?.user?.preferredLocation;
    return (
      <div className={`rewards-button-container ${className || ''}`}>
        <button
          type="button"
          className="rewards-button"
          onClick={this.props.onClick}
        >
          <img src={rewardsIcon} alt="View Rewards" />
          {!!newRewardsCount &&
            preferredLocation !== PROPERTY_CHICAGO_SOUTHLAND && (
              <div className="new-rewards-badge">{newRewardsCount}</div>
            )}
        </button>
        <span className="rewards-button-label">Rewards</span>
      </div>
    );
  }
}

RewardsButton.propTypes = {
  newRewardsCount: PropTypes.number
};

const mapDispatchToProps = dispatch => ({
  setNewRewardsCount: count => dispatch(setNewRewardsCount(count)),
  incNewRewardsCount: () => dispatch(incNewRewardsCount())
});

const mapStateToProps = createStructuredSelector({
  newRewardsCount: selectNewRewardsCount()
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withSounds({ mouseEnterSound: true }),
  withConnect,
  withApollo,
  getUserData({
    name: 'userData'
  })
)(RewardsButton);
